/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { GraphLoadingState } from '@atlassian/twg-visualization/GraphLoadingState';

import { expVal } from '@confluence/feature-experiments';

/**
 * Loading placeholder displayed while `TwgExplorerSectionContent` is being
 * lazy-loaded. Mirrors the section + graphContainer styles from
 * `TwgExplorerSectionContent` so that the layout does not shift once the
 * real content mounts.
 */
const styles = cssMap({
	// NOSONAR
	section: {
		width: '100%',
		backgroundColor: token('elevation.surface.sunken'),
		borderRadius: token('radius.small'),
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		marginTop: token('space.300'),
	},
	graphContainer: {
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		minHeight: '200px',
		marginTop: token('space.200'),
	},
});

export function TwgExplorerSectionLoadingPlaceholder(): JSX.Element | null {
	if (!expVal('cc-ai-twg-visualization', 'isEnabled', false)) {
		return null;
	}

	return (
		<div css={styles.section} data-testid="twg-explorer-section-loading">
			<div css={styles.graphContainer}>
				<GraphLoadingState />
			</div>
		</div>
	);
}
export declare namespace TwgExplorerSectionLoadingPlaceholder {
	export const displayName: string;
}

Object.assign(TwgExplorerSectionLoadingPlaceholder, {
	displayName: 'TwgExplorerSectionLoadingPlaceholder',
});
